import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import AdminUserDashboard from "../../../components/AdminUser/AdminUserDashboard";
import AdminSidebar from "../../../Container/AdminSidebar/AdminSidebar";
import PendingApproualUser from "../../../components/AdminUser/PendingApproualUser";
import PostGrid from "../../../components/AdminUser/PostGrid";
import CreateCategory from "../../../components/AdminUser/CreateCategory";
import CreateSubCategory from "../../../components/AdminUser/CreateSubCategory";
import CreateCatSub from "../../../components/AdminUser/CreateCatSub";
import RoleCatAssign from "../../../components/AdminUser/RoleCatAssign";
import RolePermissions from "../../../components/AdminUser/RolePermissions";
import EditRolePermission from "../../../components/AdminUser/EditRolePermission";
import ShowAllPost from "../../../components/Post/ShowAllPost";
import PostDetilas from "../../../components/Post/PostDetilas";
import CreatePostWithOutCat from "../../../components/ProviderUser/CreatePostWithOutCat";
import useMediaQuery from "@mui/material/useMediaQuery";

const AdminRoutes = () => {
  const isLargeScreen = useMediaQuery("(min-width:1441px)");
  return (
    <div>
      <AdminSidebar />
      <div
        style={{
          marginLeft: isLargeScreen ? 280 : 0, // Adjust margin for large and small screens
          marginTop: 25,
        }}
      >
        <Routes>
          <Route path="/admin-dashboard" element={<AdminUserDashboard />} />
          <Route
            path="/approval-pending-user"
            element={<PendingApproualUser />}
          />
          <Route path="/admin-post" element={<PostGrid />} />
          <Route path="/category" element={<CreateCategory />} />
          <Route path="/sub-categorys" element={<CreateSubCategory />} />
          <Route path="/category-subcategory" element={<CreateCatSub />} />
          <Route path="/role-cat-assign" element={<RoleCatAssign />} />
          <Route path="/role-assign" element={<RolePermissions />} />
          <Route path="/edit-role/:id" element={<EditRolePermission />} />
          <Route path="/sub-category/:id" element={<ShowAllPost />} />
          <Route path="/post-details/:id" element={<PostDetilas />} />
          <Route path="/create-post" element={<CreatePostWithOutCat />} />
        </Routes>
      </div>
    </div>
  );
};

export default AdminRoutes;
